module.exports = __webpack_public_path__ + "roboto-v15-latin-700.ad97d029a11d8b396920.ttf";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/fonts/roboto-v15-latin-700.ttf
// module id = ../../../../../src/assets/layout/fonts/roboto-v15-latin-700.ttf
// module chunks = 2